export const dashboardGrid = "grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6 min-w-0";
export const leftColumn = "lg:col-span-2 flex flex-col gap-4 md:gap-6 min-w-0";
export const innerGrid = "grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 min-w-0";
export const rightColumn = "flex flex-col gap-4 md:gap-6";
